import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { Modal, Input, H3, Text, Button } from '@bigcommerce/big-design';

import { updateShipments } from '../../redux/actions/purchaseOrders';

const AddShipmentModal = ({ payload, showAddShipmentModal, setShowAddShipmentModal, sendUpdateShipments, bigcommerceSettings, shipments, setShipments, purchaseOrderId }) => {
  const [companyName, setCompanyName] = useState(null);
  const [tracking, setTracking] = useState(null);
  const [taxes, setTaxes] = useState(null);
  const [other, setOther] = useState(null);

  const shipmentJson = () => {
    return {
      id: crypto.randomUUID(),
      company_name: companyName,
      tracking: tracking,
      taxes: taxes,
      other: other
    }
  }

  const changeCompany = (event) => {
    let value = event.target.value;
    setCompanyName(value);
  }

  const changeTracking = (event) => {
    let value = event.target.value;
    setTracking(value);
  }

  const changeTaxes = (event) => {
    let value = event.target.value;
    setTaxes(value);
  }

  const changeOther = (event) => {
    let value = event.target.value;
    setOther(value);
  }

  const update = () => {
    let newShipments = [...shipments];
    let newShipment = shipmentJson();

    newShipments.push(newShipment);
    sendUpdateShipments(payload, purchaseOrderId, newShipments);
    setShipments(newShipments);
    setShowAddShipmentModal(false);
  }

  return (
    <>
      <Modal
        actions={[
          {
            text: 'Cancel',
            variant: 'subtle',
            onClick: () => setShowAddShipmentModal(false),
          },
          { text: 'Add Shipment', onClick: () => update() },
        ]}
        closeOnClickOutside={true}
        closeOnEscKey={true}
        header="Add Shipment"
        isOpen={showAddShipmentModal}
        onClose={() => setShowAddShipmentModal(false)}
      >
        <Input
          label="Shipping Company"
          onChange={changeCompany}
          placeholder="Shipping Company"
          type="text"
          value={companyName}
          required
        />
        
        <Input
          label="Tracking #"
          onChange={changeTracking}
          placeholder="Tracking #"
          type="text"
          value={tracking}
          required
        />

        <Input
          label="Taxes/Duties"
          onChange={changeTaxes}
          placeholder="Taxes/Duties"
          type="number"
          value={taxes}
          required
        />

        <Input
          label="Other"
          onChange={changeOther}
          placeholder="Other"
          type="text"
          value={other}
          required
        />

      </Modal>
    </>
  )

}

const mapStateToProps = state => ({
  bigcommerceSettings: state.stores.settings,
});

const mapDispatchToProps = (dispatch) => ({
  sendUpdateShipments: (payload, purchaseOrderId, shipments) => dispatch(updateShipments(payload, purchaseOrderId, shipments)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddShipmentModal);
